import { render } from "./neginofogh.vue?vue&type=template&id=61b16bb8"
import script from "./neginofogh.vue?vue&type=script&lang=js"
export * from "./neginofogh.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/holdingalmas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__